import React from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import CancelIcon from '@mui/icons-material/Cancel';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const StyledCloudUploadIcon = styled(CloudUploadIcon)({
    marginRight: '0.5em',
    fontSize: '18px',
});

const StyledCancelIcon = styled(CancelIcon)({
    marginRight: '0.5em',
    fontSize: '18px',
});

const VideoUploaderActions = ({ isFileSelected, isUploading, onCancel, onSave }) => {
    return (
        <Grid container sx={{ width: '100%' }} justifyContent="center" alignItems="center" spacing={2}>
            <Grid>
                <Button
                    disabled={!isFileSelected || isUploading}
                    variant="contained"
                    color="primary"
                    onClick={onSave}
                >
                    <StyledCloudUploadIcon />
                    Upload
                </Button>
            </Grid>
            <Grid>
                <Button variant="contained" color="secondary" onClick={onCancel}>
                    <StyledCancelIcon />
                    Cancel
                </Button>
            </Grid>
        </Grid>
    );
};

VideoUploaderActions.propTypes = {
    isFileSelected: PropTypes.bool.isRequired,
    isUploading: PropTypes.bool,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default React.memo(VideoUploaderActions);
